import type { FC } from "react";

export interface SidebarGroupHeaderProps {
  label: string;
  descriptor: string;
  isActive: boolean;
}

export const SidebarGroupHeader: FC<SidebarGroupHeaderProps> = ({
  label,
  descriptor,
  isActive,
}) => (
  <div
    className={`flex items-center justify-between px-3 py-2 transition-colors ${
      isActive
        ? "text-slate-900 dark:text-slate-100"
        : "text-slate-500 dark:text-slate-400"
    }`}
  >
    <span className="flex min-w-0 items-center gap-1.5 font-mono text-[11px] font-bold uppercase tracking-[0.22em]">
      <span
        aria-hidden
        className={
          isActive
            ? "text-emerald-500/80 dark:text-emerald-400/80"
            : "text-slate-300 dark:text-slate-700"
        }
      >
        [
      </span>
      <span className="truncate">{label}</span>
      <span
        aria-hidden
        className={
          isActive
            ? "text-emerald-500/80 dark:text-emerald-400/80"
            : "text-slate-300 dark:text-slate-700"
        }
      >
        ]
      </span>
    </span>
    <span className="ml-2 flex-shrink-0 font-mono text-[9px] font-bold uppercase tracking-widest text-slate-400 dark:text-slate-500">
      {descriptor}
    </span>
  </div>
);
